import { useContext } from "react";

import styles from "./TableCards.module.scss";
import { useScrollbarWidth } from "src/hooks";
import { genericMemo } from "src/utils";

// Inner imports
import type { TableItemGenericProps, TableProps } from "../../types";
import { TableContext } from "../../context";
import { TableCard } from "./components";

type Props<T> = Pick<
  TableProps<T>,
  "items" | "tableColumns" | "getActionMenuOptions"
>;

export const TableCards = genericMemo(
  <T extends TableItemGenericProps>({
    items,
    tableColumns,
    getActionMenuOptions,
  }: Props<T>) => {
    const { contentRef } = useContext(TableContext);

    const scrollbarWidth = useScrollbarWidth();

    return (
      <div
        className={styles.tableCards}
        style={{
          width: `calc(100% + ${scrollbarWidth}px`,
        }}
        ref={contentRef}
      >
        {items.map((item) => (
          <TableCard
            key={item.id}
            item={item}
            tableColumns={tableColumns}
            getActionMenuOptions={getActionMenuOptions}
          />
        ))}
      </div>
    );
  },
);
